import { useEffect } from 'react';
import { initWebVitals } from '@/utils/webVitals';

/**
 * Lightweight performance optimizer.
 * Previous version loaded CLSOptimizer, INPOptimizer, PerformanceOptimizer
 * which caused ~3s TBT via DOM manipulation and addEventListener monkey-patching.
 * Now only initializes Web Vitals tracking after idle.
 */
export function DeferredOptimizers() {
  useEffect(() => {
    const load = () => {
      // Initialize Web Vitals tracking (lightweight, no DOM manipulation)
      initWebVitals();

      // Passive prefetch on hover for internal links
      const prefetched = new Set<string>();
      const handleHover = (e: Event) => {
        const anchor = (e.target as HTMLElement).closest('a');
        if (!anchor?.href) return;
        try {
          const url = new URL(anchor.href);
          if (url.origin === window.location.origin && !prefetched.has(url.pathname) && prefetched.size < 15) {
            prefetched.add(url.pathname);
            const link = document.createElement('link');
            link.rel = 'prefetch';
            link.href = url.pathname;
            document.head.appendChild(link);
          }
        } catch { /* ignore */ }
      };
      document.addEventListener('mouseover', handleHover, { passive: true });
      document.addEventListener('focusin', handleHover, { passive: true });
    };

    if ('requestIdleCallback' in window) {
      requestIdleCallback(load, { timeout: 3000 });
    } else {
      setTimeout(load, 2000);
    }
  }, []);

  return null;
}
